import { Router } from '@angular/router';
import { SwitchProfileComponent } from './../profile/switch-profile/switch-profile.component';
import { MatDialog } from '@angular/material/dialog';
import { Subscription } from 'rxjs';
import { take } from 'rxjs/operators';
import { DashboardEventService } from './../dashboard/dashboard-event.service';
import { Message } from 'primeng/api';
import { ApplicationConfigurationComponent } from './../application-configuration/application-configuration.component';
import { PollingStatus } from './../service/polling-status';
import { CognitoUtil } from './../authentication/cognito.service';
import { ServiceRegistry } from './../service/service-registry.service';
// import { TroubleMaker } from './../service/trouble-maker';
import { HttpClient } from '@angular/common/http';
import { AlertComponent } from '../alert/alert.component';
import { Component, Inject, forwardRef, ViewChild, AfterViewInit, OnInit, OnDestroy } from '@angular/core';
import { HomeComponent } from './home.component';
import { SystemMessage } from '@liquitics/transaction';
import { TerminalService } from 'primeng/terminal';
import { DebugTerminalHandler } from '../debug/debug-terminal-handler';
import { AppConfig } from '../app.config';
import { UserLoginService } from '../authentication/user-login.service';
import { DocumentationDialogComponent } from '../documentation/documentation-dialog.component';

@Component({
    selector: 'app-home-topbar',
    templateUrl: './home.topbar.component.html',
    styleUrls: ['./home.topbar.component.scss'],
    providers: [TerminalService]
})
export class HomeTopBarComponent implements OnInit, OnDestroy {

    @ViewChild(AlertComponent, { static: true })
    alertComponent: AlertComponent;

    @ViewChild(ApplicationConfigurationComponent, { static: true })
    applicationConfigurationComponent: ApplicationConfigurationComponent;

    notificationCount = 0;

    alertCount = 0;

    aboutVisible = false;
    debugVisible = false;
    emergencyMessages: Message[] = [];
    systemMessages: SystemMessage[];

    buildNum: string;
    buildSha1: string;
    buildDate: string;
    pipelineNumber: string;

    pollingStatus: string;
    debugTerminalHandler: DebugTerminalHandler;

    subscription: Subscription;

    // constructor( @Inject(forwardRef(() => HomeComponent)) public app: HomeComponent,
    constructor(
        private http: HttpClient,
        private serviceRegistry: ServiceRegistry,
        private cognitoUtil: CognitoUtil,
        private dashboardEventService: DashboardEventService,
        public appConfig: AppConfig,
        private dialog: MatDialog,
        private router: Router,
        private terminalService: TerminalService,
        public userService: UserLoginService
        // public troubleMaker: TroubleMaker,
    ) {
        this.debugTerminalHandler = new DebugTerminalHandler(appConfig, dashboardEventService);
    }

    initializeTopBar() {
        this.applicationConfigurationComponent.initializeApplicationConfigurationComponent();
    }

    ngOnInit() {
        this.http.get('assets/build.json')
            .pipe(take(1))
            .subscribe({
                next: (data) => {
                    const json: any = data;
                    this.buildNum = json.buildNum;
                    this.buildSha1 = json.buildSha1;
                    this.buildDate = json.buildDate;
                    this.pipelineNumber = json.pipelineNumber;
                }
            });
        this.subscription = this.dashboardEventService.emergencyMessageSubject.subscribe({
            next: message => {
                if (this.emergencyMessages.filter(msg => {
                    return (msg.summary === message.summary && msg.detail === message.detail);
                })
                    .length === 0) {
                    this.emergencyMessages.push(message);
                }
            }
        });
        this.subscription = this.dashboardEventService.systemMessageSubject.subscribe({
            next: messages => {
                this.systemMessages = messages;
            }
        });
        this.subscription.add(this.serviceRegistry.pollingStatus.subscribe({
            next: status => {
                this.pollingStatus = status;
            }
        }));
        this.subscription.add(this.terminalService.commandHandler.subscribe({
            next: command => {
                this.terminalService.sendResponse(this.debugTerminalHandler.handleTerminalCommand(command));
            }
        }));
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    onAlertCountChange(count: number) {
        this.alertCount = count;
    }

    toggleHeartbeat(event) {
        // this.cognitoUtil.getCurrentUser().getUserAttributes((err, result) => {
        //     if (err) {
        //         console.log("Failed to retrieve user attributes:" + err);
        //     } else {
        //         console.log("Retrieved the following attributes:" + JSON.stringify(result));
        //     }
        // });
        if (this.pollingStatus === PollingStatus.FIXED_DATE) {
            this.dashboardEventService.restartLive();
        } else if (this.pollingStatus === PollingStatus.PAUSED) {
            this.serviceRegistry.resumePollingServices();
        } else {
            this.serviceRegistry.pausePollingServices();
        }
    }

    applicationConfigurationVisible() {
        this.applicationConfigurationComponent.applicationConfigurationVisible = true;
    }

    severity(systemMessage: SystemMessage): string {
        if (systemMessage.severity === 'CRITICAL') {
            return 'error';
        } else if (systemMessage.severity === 'WARN') {
            return 'warn';
        } else if (systemMessage.severity === 'INFO') {
            return 'info';
        }
    }

    openChangeProfileDialog() {
        setTimeout(() => {
            const dialogRef = this.dialog.open(SwitchProfileComponent, {
                // width: '20%',
                data: {
                }
            });
        }, 50);
    }


    openDocumentationDialog() {
        setTimeout(() => {
            const dialogRef = this.dialog.open(DocumentationDialogComponent, {
                width: '60%',
                height: '60%',
                data: {
                }
            });
        }, 50);
    }

    logout() {
        this.userService.logoutAsync()
            .then(() => {
                this.router.navigateByUrl('/loggedout')
                    .then((success: boolean) => {
                        console.log(`Logout: ${success}`);
                    })
                    .catch((err) => {
                        console.log('Logout error:' + err);
                    });
            });
    }
    // invalidateSession() {
    //     this.troubleMaker.invalidateSessionPermanently()
    // }
}
